import { render, staticRenderFns } from "./SvgImage.vue?vue&type=template&id=799562b2&scoped=true"
import script from "./SvgImage.vue?vue&type=script&lang=js"
export * from "./SvgImage.vue?vue&type=script&lang=js"
import style0 from "./SvgImage.vue?vue&type=style&index=0&id=799562b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799562b2",
  null
  
)

export default component.exports